import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HIDE_PREVIEW_MENU, MainLayoutComponent } from '../main-layout/main-layout.component';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';
import { Dto } from '@damofire/data-commons';
import { EmitterService } from '../emitter.service';
import { deleteDoc, DocumentReference } from '@angular/fire/firestore';

@AutoUnsubscribe()
@Directive()
export class GridCard<T extends Dto<any>> implements OnInit {
  protected _item: T;

  @Input()
  doc: DocumentReference;

  @Input()
  active: boolean;

  @Input()
  showOptions: boolean;

  @Input()
  editHidden: boolean;

  @Input()
  border = 'regular';

  @Output()
  editBtnClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  domId: string;
  deleting = false;

  protected readonly viewSubs = new SubSink();

  constructor(protected readonly emitterService: EmitterService) {}

  triggerEditEvent(): void {
    this.editBtnClicked.next(true);
  }

  ngOnInit(): void {
    // For child use
  }

  @Input()
  set item(item: T) {
    this._item = item;
    this.itemChanged(item);
  }

  get item(): T {
    return this._item;
  }

  itemChanged(item: T): void {
    this.domId = `${item?._id}${this.showOptions ? '-card' : ''}`;
  }

  deleteDocument(): void {
    this.deleting = true;
    deleteDoc(this.doc).then(() => this.documentDeleted());
  }

  protected documentDeleted(): void {
    this.deleting = false;
    this.emitterService.get(MainLayoutComponent.channelName()).next({ event: HIDE_PREVIEW_MENU, value: true });
  }
}
